(() => {
  const SELECTOR = '#ProductGridContainer #product-grid';
  const CARD_CLASS = 'fa-collection-review-card-item';
  const REPUTON_SRC = 'https://cdn.grw.reputon.com/assets/widget.js?shop=floweradvisor-my.myshopify.com';
  let reviewCard = null;
  let observer = null;
  let visibilityObserver = null;
  let scheduled = false;
  let reputonRequested = false;

  const isFirstPage = () => {
    const page = Number(new URL(window.location.href).searchParams.get('page') || '1');
    return !Number.isFinite(page) || page <= 1;
  };

  const buildCard = () => {
    if (reviewCard) return reviewCard;

    reviewCard = document.createElement('section');
    reviewCard.className = CARD_CLASS;
    reviewCard.setAttribute('aria-label', 'Google customer reviews');
    reviewCard.innerHTML = `
      <div class="fa-collection-review-card">
        <div class="fa-collection-review-card__widget">
          <div class="reputon-google-reviews-widget" data-type="grid" data-content-index="1" data-theme="light" data-review-photos-type="small" data-write-review="true" data-show-rating="true" data-fixed-reviews-height="true" data-transparency="1" data-number-of-rows-mobile="1" data-number-of-rows-desktop="1" data-font="default" data-solid-shadow="false" data-rating-type="stars"></div>
        </div>
      </div>`;

    return reviewCard;
  };

  const requestReputon = () => {
    if (reputonRequested) return;
    reputonRequested = true;

    const existing = Array.from(document.scripts).find((script) => script.src && script.src.includes('cdn.grw.reputon.com/assets/widget.js'));
    if (existing) return;

    const script = document.createElement('script');
    script.src = REPUTON_SRC;
    script.defer = true;
    script.dataset.faCollectionReputon = 'true';
    document.head.appendChild(script);
  };

  const watchVisibility = () => {
    if (!reviewCard || reputonRequested) return;

    if (!('IntersectionObserver' in window)) {
      requestReputon();
      return;
    }

    if (!visibilityObserver) {
      visibilityObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          requestReputon();
          visibilityObserver.disconnect();
          visibilityObserver = null;
        }
      }, { rootMargin: '700px 0px' });
    }

    visibilityObserver.observe(reviewCard);
  };

  const placeCard = () => {
    const grid = document.querySelector(SELECTOR);
    if (!grid) return;

    const productItems = Array.from(grid.children).filter((item) => item.matches('.grid__item'));

    if (!isFirstPage() || productItems.length === 0) {
      if (reviewCard && reviewCard.parentElement) reviewCard.remove();
      return;
    }

    const card = buildCard();
    const collection = grid.closest('.collection') || grid.parentElement;
    const pagination = collection?.querySelector(':scope > .pagination-wrapper');
    const anchor = pagination || grid;
    const inCorrectPlace = card.parentElement === anchor.parentElement && card.previousElementSibling === anchor;

    if (!inCorrectPlace) anchor.insertAdjacentElement('afterend', card);
    watchVisibility();
  };

  const schedulePlace = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      placeCard();
    });
  };

  const init = () => {
    placeCard();
    const container = document.querySelector('#ProductGridContainer');
    if (!container) return;

    observer = new MutationObserver(schedulePlace);
    observer.observe(container, { childList: true, subtree: true });
    window.addEventListener('popstate', schedulePlace, { passive: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
